<template>
  <form
    novalidate
    @submit.prevent="validateBeforeSubmit(formScope)"
    :data-vv-scope="formScope"
    enctype="multipart/form-data"
    id="form-search"
  >
    <p>{{$t('Давайте сделаем наш поиск еще лучше.')}}</p>
    <p class="mb-6">{{$t('Заполните небольшую форму.')}}</p>

    <div class="d-flex justify-space-between mb-6">
      <bim-input
        name="name"
        v-model="input.first_name"
        v-validate="'required'"
        :valid="errors.has('name', formScope) ? false : null"
        :placeholder="$t('Имя')"
        style="width: 100%"
        class="mr-6"
      />
      <bim-input
        name="email"
        v-model="input.email"
        v-validate="'required|email'"
        :valid="errors.has('email', formScope) ? false : null"
        :placeholder="$t('Электронная почта')"
        style="width: 100%"
      />
    </div>

    <!--errors.has('message', formScope)-->
    <bim-textarea
      width="100%"
      name="message"
      v-model="input.textmessage"
      v-validate="'required'"
      :placeholder="$t('Что бы вы хотели видеть на портале?')"
      class="not-found-textarea mb-7"
      :class="{error: errors.has('message', formScope)}"
    ></bim-textarea>

    <bim-checkbox
      v-model="agree"
      id="agree"
      :data-vv-as="$t('Соглашение')"
      name="agreement"
      class="mb-9"
    >
      <label for="agree">{{$t('Я согласен с ')}}
        <a
          href="/privacy/"
          rel="nofollow"
          target="_blank"
          class="link-main link-main--solid-small link-main--border-green d-inline"
        >{{$t('Политикой конфиденциальности')}}
        </a>
      </label>
    </bim-checkbox>

    <div class="d-flex justify-space-between">
      <bim-button
        class="ml-auto mr-6"
        color="gray"
        @click.prevent="$emit('close')"
        label="Отменить"
      />

      <bim-button :disabled="!agree || loading" label="Отправить" />
    </div>
  </form>
</template>

<script>
import bimInput from '@bimlib/components/bimInput'
import bimTextarea from '@bimlib/components/bimTextarea'
import bimCheckbox from '@bimlib/components/bimCheckbox'

export default {
  components: { bimInput, bimTextarea, bimCheckbox },
  data () {
    return {
      formScope: 'did-find',
      priority: 'normal',
      group_id: 53399,
      input: {
        email: '',
        first_name: '',
        textmessage: '',
      },
      loading: false,
      agree: true,
    }
  },
  methods: {
    validateBeforeSubmit (scope) {
      this.$validator
        .validateAll(scope)
        .then(result => {
          if (result && this.agree) {
            this.loading = true
            const params = new FormData()
            params.append('user_email', this.input.email)
            params.append('user_full_name', this.input.first_name)
            params.append('content', this.input.textmessage)
            params.append('group_id', this.group_id)
            params.append('priority', this.priority)

            axios
              .post('/?m=Statics&a=Create_ticket_search', params)
              .then(response => {
                if (response.data.case.status === 'open') {
                  this.$toast('Спасибо, мы рассмотрим вашу заявку в ближайшее время!')
                  this.$emit('close')
                } else if (response.case.status === 'error') {
                  this.$toast('Что-то пошло не так... Пожалуйста, попробуйте снова')
                }
              })
              .catch(error => {
                this.$toast('Что-то пошло не так... Пожалуйста, попробуйте снова')
                console.error(error)
              })
              .finally(() => this.loading = false)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>

<style lang="scss">
@import "../../../sass/components/color";


.not-found-textarea.error {
  border : 1px solid $error;
}
</style>
